module.exports = __webpack_public_path__ + "static/media/67968354-ac43-4ef6-a91c-9a3cc4c141ef-inactive.f22156a9.png";